import { Component, OnInit, ViewEncapsulation, Input, Output } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { MarketingOffer } from '../../models/presentation.model';

@Component({
  selector: 'mkt-hero',
  templateUrl: './mkt-hero.component.html',
  styleUrls: ['./mkt-hero.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MktHeroComponent implements OnInit {

  @Input()
  marketingOffers: Array<MarketingOffer>;
  @Output()
  searchById: EventEmitter<string>= new EventEmitter<string>();
  constructor() { }

  ngOnInit() {
  }

  public triggerSearch(searchId: string):void{
    this.searchById.emit(searchId);
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/hero/mkt-hero/mkt-hero.component.ts